import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Configuration from "../configuration";
var token = localStorage.getItem("x-access-token");

export const fetchRootBase = createAsyncThunk("root/fetchRootBase", async () => {
  const response = await fetch(Configuration.BACK_BASEURL + "root/allRoot", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },

  });
  const rootBase = await response.json();
  return rootBase;
});

export const getRootByRole = createAsyncThunk("root/getRootByRole", async (action) => {
  const id_site = action.id_site.join(',');  // joins array to "2,3"

  const url = `${Configuration.BACK_BASEURL}root/getRootByRole/${action.role}/${action.client}/${id_site}/${action.view}`;

  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    }
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch: ${response.statusText}`);
  }

  const rootBase = await response.json();
  return rootBase;
});


export const rootGetById = createAsyncThunk("root/rootGetById", async (id) => {
  const response = await fetch(Configuration.BACK_BASEURL + "root/getRoot/" + id, {
    method: 'get',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
  });
  const rootBase = await response.json();
  return rootBase;
});

export const rootBaseDeleted = createAsyncThunk("root/deleteRoot", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "root/deleteRoot/" + action.id, {
    method: 'DELETE',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
  });
  const rootBase = await response.json();
  return rootBase;
});
const rootBaseReduce = createSlice({
  name: "rootBase",
  initialState: {
    entities: [],
    loading: false,
  },
  reducers: {
    rootBaseAdded(state, action) {
      fetch(Configuration.BACK_BASEURL + "root/addRoot", {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'x-access-token': token
        },
        body: JSON.stringify(action.payload)
      });
    },
    /* rootBaseDeleted(state, action) {
      const { id } = action.payload;
      fetch(Configuration.BACK_BASEURL + "root/deleteRoot/"+id, {
        method: 'DELETE',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'x-access-token':token
        },
      });
    }, */

  },
  extraReducers: {

    [fetchRootBase.pending]: (state, action) => {
      state.loading = true;
    },
    [fetchRootBase.fulfilled]: (state, action) => {
      state.loading = false;
      state.entities = [...state.entities, ...action.payload];
    },
    [fetchRootBase.rejected]: (state, action) => {
      state.loading = false;
    },
    [getRootByRole.pending]: (state, action) => {
      state.loading = true;
    },
    [getRootByRole.fulfilled]: (state, action) => {
      state.loading = false;
      state.rootBase = [...state.entities, action.payload];
    },
    [getRootByRole.rejected]: (state, action) => {
      state.loading = false;
    },
  },
});

export const { rootBaseAdded } = rootBaseReduce.actions;

export default rootBaseReduce.reducer;
